import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[sessionHost]',
})
export class SessionDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}